var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDiagonalSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 9.93"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M8.57 0H2.38v1.43h5.11L0 8.92l1.01 1.01 7.56-7.56v5.25H10V0H8.57z"
  })));
}

export default SvgArrowDiagonalSmall;